import { isEmpty, pickBy } from 'lodash'
import { parseRef, scrubUndefined } from "../../firebase"
import { defaultListener, generateId } from "../helper"
import drawers from "./drawers"

export default {
  state: {
    eventGroups: {}
  },
  getters: {
    getEventGroupsByEventId: (state) => (eventId) => {
      return pickBy(state.eventGroups, eventGroup => eventGroup.eventId === eventId)
    },
    allEventGroups: (state) => returnMap => {
      return returnMap
        ? state.eventGroups
        : Object.values(state.eventGroups)
    }
  },
  actions: {
    initEventGroups({ commit, getters }, eventId) {
      const sessionTenant = getters.getSessionTenant

      if (!isEmpty(eventId)) {
        this.$firebase.firestore()
          .collection('tenants')
          .doc(sessionTenant)
          .collection('eventGroups')
          .where('eventId', '==', eventId)
          .onSnapshot(
            defaultListener.bind(this, commit, 'ADD_EVENT_GROUP', 'REMOVE_EVENT_GROUP'),
            e => console.log('group error', e)
          )
      }
    },
    ensureEventGroups({ commit, getters }, eventId) {
      const sessionTenant = getters.getSessionTenant

      if (!isEmpty(eventId)) {
        this.$firebase.firestore()
          .collection('tenants')
          .doc(sessionTenant)
          .collection('eventGroups')
          .where('eventId', '==', eventId)
          .get()
          .then(ref => {
            const items = parseRef(ref)

            if (items) items.forEach(item => commit('ADD_EVENT_GROUP', item))
          })
          .catch(e => console.log(e))
      }
    },
    createEventGroup({ getters }, data) {
      const {
        label = '',
        completeEvent = '',
        eventId = ''
      } = data

      const payload = { label, completeEvent, eventId }

      const merge = true
      const sessionTenant = getters.getSessionTenant
      const id = generateId(sessionTenant, 'eventGroups')

      scrubUndefined(payload)

      this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('eventGroups')
        .doc(id)
        .set(payload, { merge })
        .catch(e => console.log(e))
    },
    async updateEventGroup({ getters }, data) {
      const { label, completeEvent, eventId, id } = data
      const payload = { label, completeEvent, eventId }

      const merge = true
      const sessionTenant = getters.getSessionTenant

      scrubUndefined(payload)

      await this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('eventGroups')
        .doc(id)
        .set(payload, { merge })
        .catch(e => console.log(e))
    },
    async deleteEventGroup({ getters }, data) {
      const { id } = data

      const sessionTenant = getters.getSessionTenant

      await this.$db
        .collection('tenants')
        .doc(sessionTenant)
        .collection('eventGroups')
        .doc(id)
        .delete()
    },
    async addCompleteEventToGroup({ getters, dispatch }, data) {
      const { label = '', description = '', id } = data

      const eventPayload = {
        label,
        description,
        isActive: true,
        isArchived: false
      }

      await dispatch('createEvent', eventPayload)

      const sessionTenant = getters.getSessionTenant
      const merge = true
      const eventId = generateId(sessionTenant, 'events')

      const updateEventGroupWithCompleteEvent = () => {
        const eventGroupPayload = { completeEvent: eventId, id }
        dispatch('updateEventGroup', eventGroupPayload)
      }

      this.$firebase.firestore()
        .collection('tenants')
        .doc(sessionTenant)
        .collection('events')
        .doc(eventId)
        .set(eventPayload, { merge })
        .then(updateEventGroupWithCompleteEvent)
        .catch(e => console.log(e))
    }
  },
  mutations: {
    ADD_EVENT_GROUP(state, eventGroup) {
      const { id } = eventGroup

      if (id) {
        const newState = { ...state.eventGroups }
        newState[ id ] = eventGroup
        state.eventGroups = newState
      }
    },
    REMOVE_EVENT_GROUP(state, id) {
      if (state.eventGroups[ id ]) {
        const newState = { ...state.eventGroups }
        delete newState[ id ]
        state.eventGroups = newState
      }
    }
  },
}
